import { useEffect, useState } from 'react';
import { ArrowLeft, RotateCcw } from 'lucide-react';
import { BrandLogo } from './BrandLogo';
import { LegalFooter } from './LegalFooter';
import { operatorDetails } from '../data/legalPages';
import { requestReturn } from '../lib/commerceApi';
import { mailtoFallbackMessage } from '../lib/leadCaptureGate';

export function ReturnRequestPage() {
  const [message, setMessage] = useState('Vul je ordergegevens en retourvraag in.');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    document.title = 'Retour aanmelden | ProPickleball.nl';
  }, []);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const requestType = String(data.get('requestType') ?? '').trim();
    const orderNumber = String(data.get('orderNumber') ?? '').trim();
    const name = String(data.get('name') ?? '').trim();
    const email = String(data.get('email') ?? '').trim();
    const products = String(data.get('products') ?? '').trim();
    const receivedAt = String(data.get('receivedAt') ?? '').trim();
    const reason = String(data.get('reason') ?? '').trim();
    const fullReason = [
      `Type melding: ${requestType}`,
      `Naam: ${name}`,
      `Producten: ${products}`,
      `Ontvangen op: ${receivedAt || 'niet ingevuld'}`,
      '',
      reason
    ].join('\n');
    setIsSubmitting(true);
    try {
      await requestReturn({ orderNumber, email, reason: fullReason });
      setMessage('Je retourvraag is ontvangen. We volgen deze per e-mail op.');
      event.currentTarget.reset();
    } catch (error) {
      const body = [
        'Retouraanmelding ProPickleball.nl',
        '',
        `Type melding: ${requestType}`,
        `Ordernummer: ${orderNumber}`,
        `Naam: ${name}`,
        `E-mailadres: ${email}`,
        `Producten: ${products}`,
        `Ontvangen op: ${receivedAt || 'niet ingevuld'}`,
        '',
        `Vraag/reden: ${reason}`
      ].join('\n');
      window.location.href = `mailto:${operatorDetails.email}?subject=${encodeURIComponent('Retouraanmelding ProPickleball.nl')}&body=${encodeURIComponent(body)}`;
      setMessage(mailtoFallbackMessage(error, operatorDetails.email));
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <main className="checkoutPage">
        <nav className="productTopbar" aria-label="Retour navigatie">
          <BrandLogo compact />
          <a className="backHome" href="/retouren/"><ArrowLeft size={18} /> Retourinformatie</a>
        </nav>
        <section className="checkoutShell">
          <div className="cartHeading">
            <p className="eyebrow">Retour aanmelden</p>
            <h1>Regel je retour of melding.</h1>
            <p>
              Gebruik dit formulier voor herroeping, retour, defect, transportschade of een productveiligheidsmelding.
              Retouradres: {operatorDetails.returnAddress}. Stuur producten pas terug nadat je retourroute is bevestigd.
            </p>
          </div>
          <form className="checkoutForm" onSubmit={handleSubmit}>
            <label>
              Type melding
              <select name="requestType" required>
                <option value="">Kies een optie</option>
                <option value="Herroeping binnen bedenktijd">Herroeping binnen bedenktijd</option>
                <option value="Retourvraag">Retourvraag</option>
                <option value="Defect of garantie">Defect of garantie</option>
                <option value="Transportschade">Transportschade</option>
                <option value="Productveiligheidsmelding">Productveiligheidsmelding</option>
              </select>
            </label>
            <label>
              Ordernummer
              <input name="orderNumber" placeholder="PPB-..." required />
            </label>
            <label>
              Naam
              <input name="name" placeholder="Voor- en achternaam" required />
            </label>
            <label>
              E-mailadres
              <input name="email" type="email" placeholder="naam@example.com" required />
            </label>
            <label>
              Product(en)
              <input name="products" placeholder="Bijvoorbeeld: starterset, paddle of net" required />
            </label>
            <label>
              Ontvangen op
              <input name="receivedAt" type="date" />
            </label>
            <label>
              Vraag of retourreden
              <textarea name="reason" placeholder="Beschrijf wat je wilt retourneren of wat er mis is. Voeg bij schade of veiligheid ook foto's toe in de e-mailreactie." required rows={5} />
            </label>
            <button type="submit" disabled={isSubmitting}><RotateCcw size={18} /> {isSubmitting ? 'Versturen...' : 'Retourvraag versturen'}</button>
            <p className="formNote" role="status">{message}</p>
            <p className="formNote">
              Bij herroeping beoordelen we de 14-dagentermijn vanaf ontvangst. Bij garantie of veiligheid vragen we meestal om foto,
              video, batch/labelinformatie en een korte beschrijving van het gebruik.
            </p>
          </form>
        </section>
      </main>
      <LegalFooter />
    </>
  );
}
